export interface Transaction {
  id: string;
  type: 'deposit' | 'withdraw' | 'buy' | 'sell';
  label: string;
  amount: number;
  status: 'pending' | 'approved' | 'rejected' | 'success';
  date: string;
  detail: string;
}

export const transactions: Transaction[] = [
  { id: 'tx1', type: 'deposit', label: 'Nạp tiền', amount: 100000000, status: 'success', date: '14/08/2026 10:20', detail: 'Chuyển khoản ngân hàng Vietcombank' },
  { id: 'tx2', type: 'buy', label: 'Mua vàng', amount: -288000000, status: 'success', date: '14/08/2026 15:40', detail: 'Mua 2 lượng SJC 9999' },
  { id: 'tx3', type: 'sell', label: 'Bán vàng', amount: 141000000, status: 'success', date: '10/08/2026 11:05', detail: 'Bán 1 lượng DOJI 9999' },
  { id: 'tx4', type: 'withdraw', label: 'Rút tiền', amount: -50000000, status: 'approved', date: '09/08/2026 14:30', detail: 'Rút về tài khoản Techcombank' },
  { id: 'tx5', type: 'withdraw', label: 'Rút tiền', amount: -20000000, status: 'pending', date: '08/08/2026 09:10', detail: 'Rút về tài khoản Vietcombank' },
  { id: 'tx6', type: 'deposit', label: 'Nạp tiền', amount: 50000000, status: 'success', date: '05/08/2026 16:45', detail: 'Chuyển khoản ngân hàng Techcombank' },
];

export interface Asset {
  id: string;
  name: string;
  code: string;
  quantity: number;
  unit: string;
  buyPrice: number;
  currentPrice: number;
}

export const assets: Asset[] = [
  { id: 'a1', name: 'Vàng miếng SJC 1L', code: 'SJC 1L', quantity: 5, unit: 'lượng', buyPrice: 138000000, currentPrice: 144000000 },
  { id: 'a2', name: 'Nhẫn tròn SJC 9999', code: 'SJC 9999', quantity: 8, unit: 'lượng', buyPrice: 136000000, currentPrice: 143500000 },
  { id: 'a3', name: 'Vàng DOJI 9999', code: 'DOJI', quantity: 3, unit: 'lượng', buyPrice: 137500000, currentPrice: 144000000 },
];

export interface AdminUser {
  id: string;
  name: string;
  email: string;
  phone: string;
  balance: number;
  kyc: 'verified' | 'pending' | 'rejected';
  status: 'active' | 'locked';
  joined: string;
}

export const adminUsers: AdminUser[] = [
  { id: 'u1', name: 'Nguyễn Văn An', email: 'an.nguyen@gmail.com', phone: '0901234567', balance: 520000000, kyc: 'verified', status: 'active', joined: '12/03/2026' },
  { id: 'u2', name: 'Trần Thị Bích', email: 'bich.tran@gmail.com', phone: '0912345678', balance: 180000000, kyc: 'pending', status: 'active', joined: '25/04/2026' },
  { id: 'u3', name: 'Lê Hoàng Minh', email: 'minh.le@gmail.com', phone: '0923456789', balance: 920000000, kyc: 'verified', status: 'active', joined: '03/02/2026' },
  { id: 'u4', name: 'Phạm Quốc Bảo', email: 'bao.pham@gmail.com', phone: '0934567890', balance: 45000000, kyc: 'rejected', status: 'locked', joined: '18/05/2026' },
  { id: 'u5', name: 'Vũ Thị Hồng', email: 'hong.vu@gmail.com', phone: '0945678901', balance: 760000000, kyc: 'verified', status: 'active', joined: '07/01/2026' },
];

export interface AdminRequest {
  id: string;
  user: string;
  type: 'deposit' | 'withdraw';
  amount: number;
  bank: string;
  status: 'pending' | 'approved' | 'rejected';
  date: string;
}

export const adminRequests: AdminRequest[] = [
  { id: 'r1', user: 'Nguyễn Văn An', type: 'deposit', amount: 200000000, bank: 'Vietcombank', status: 'pending', date: '15/08/2026 09:30' },
  { id: 'r2', user: 'Trần Thị Bích', type: 'withdraw', amount: 50000000, bank: 'Techcombank', status: 'pending', date: '15/08/2026 08:45' },
  { id: 'r3', user: 'Lê Hoàng Minh', type: 'deposit', amount: 350000000, bank: 'BIDV', status: 'approved', date: '14/08/2026 16:20' },
  { id: 'r4', user: 'Vũ Thị Hồng', type: 'withdraw', amount: 120000000, bank: 'VietinBank', status: 'approved', date: '14/08/2026 11:10' },
  { id: 'r5', user: 'Phạm Quốc Bảo', type: 'withdraw', amount: 30000000, bank: 'ACB', status: 'rejected', date: '13/08/2026 14:00' },
];